export default "__VITE_ASSET__sRc6cTeY__"